import { IPartner } from '../partner/partner';
import { IPaginationParams } from '../global/pagination';
import { ISortParams } from '../global/sort';
import { ITravellerInfo } from '../journey/journey';

export interface IBooking {
  id: number;
  created: string;
  updated: string;
  totalPrice: number;
  journeyCount: number;
  bookerInfo: IBookerInfo;
  code: string;
  pinCode: string;
  travelIntent: string;
  partnerId: number;
  partnerReference: string;
  prepaid: boolean;
  partner: IPartner;
  currencyCode: string;
  paymentRequestReference: IPaymentRequestReference;
  creationInfo: ICreationInfo;
}

export interface IPaymentRequestReference {
  paymentServicePaymentRequestId: number;
}

export interface IBookerInfo {
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  companyName?: string;
  reference?: string;
  traveller?: boolean;
  receiveJourneyUpdates?: boolean;
  languageIsoCode?: string;
}

export interface ICreationInfo {
  source: string;
}

export interface IBookingsRequestParams extends IPaginationParams, ISortParams {
  partnerId?: number;
  id?: number;
  bookingCode?: string;
  createdAfter?: string;
  createdBefore?: string;
}

export interface IPaymentLink {
  url: string;
  expiresAt: string;
}

export enum TravelIntentType {
  Business = 'BUSINESS',
  Leisure = 'LEISURE',
  Unknown = 'UNKNOWN',
}

export const TravelIntentDisplayName = {
  [TravelIntentType.Business]: 'Business',
  [TravelIntentType.Leisure]: 'Leisure',
  [TravelIntentType.Unknown]: 'Unknown',
};

export enum PortalType {
  PartnerPortal = 'PARTNER_PORTAL',
  BackofficePortal = 'BACK_OFFICE',
  WhileLabel = 'WHITE_LABEL',
  Api = 'API'
}

export const PortalDisplayName = {
  [PortalType.PartnerPortal]: 'Partner Portal',
  [PortalType.BackofficePortal]: 'Backoffice Portal',
  [PortalType.WhileLabel]: 'Whitelabel',
  [PortalType.Api]: 'Api',
};

export interface IBookingParams {
  travelIntent: string;
  partnerReference: string;
  creationSource: string;
  bookerInfo: IBookerInfo;
  quotes?: IBookingQuote[];
  partnerId?: number;
}

export interface IBookingQuote {
  quoteId: number;
  quoteTravelAddons: IBookingQuoteTravelAddon[];
  travellerInfo?: ITravellerInfo;
}

export interface IBookingQuoteTravelAddon {
  quoteTravelAddonId: number;
  amount: number;
}

export interface IUnresolvedAlertsRequestParams {
  journeyId?: number;
  bookingId?: number;
}

export enum UnresolvedAlertType {
  IncorrectTravellerPhone = 'INCORRECT_TRAVELLER_PHONE',
  IncorrectFlightNumber = 'INCORRECT_FLIGHT_NUMBER',
  FlightNumberNotProvided = 'FLIGHT_NUMBER_NOT_PROVIDED',
  FlightNumberNotFound = 'FLIGHT_NUMBER_NOT_FOUND',
  FlightNumberIncorrectAirport = 'FLIGHT_NUMBER_INCORRECT_AIRPORT',
}

export const UnresolvedAlertDisplayName = {
  [UnresolvedAlertType.IncorrectFlightNumber]: 'Incorect flight number',
  [UnresolvedAlertType.IncorrectTravellerPhone]: 'Incorrect traveller phone',
  [UnresolvedAlertType.FlightNumberIncorrectAirport]: 'Flight number incorrect airport',
  [UnresolvedAlertType.FlightNumberNotFound]: 'Flight number not found',
  [UnresolvedAlertType.FlightNumberNotProvided]: 'Flight number incorrect airport',
};

export interface IUnresolvedAlert {
  id: number;
  created: string;
  updated: string;
  type: string;
  journeyIds: number[];
  phone?: string;
  journeyCode?: string;
  flightNumber?: string;
}

export interface IRefundBookingParams {
  amount: number;
  currencyCode: string;
}

export interface ITotalRefundableAmount {
  amount: number;
  currencyCode: string;
}
